// Import Packages
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from "recoil";

// Import Material UI
import { Box, Select, MenuItem, FormControl, TextField, Checkbox } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

// Import pages
import { TextInput } from '../TextInput/NewTextInput';

// Import Recoil
import { inputRefresh } from "../../../recoil-store/recoil-state";

// Import CSS
import '../CredentialPicker/CredentialPicker.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function TabPanel({ children, value, index }) {
    return (<div>{value === index && (<Box>{children}</Box>)}</div>);
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function CustomTab({ action, inputName, options, variables, setOpenVariable, variableRender, setField, type, displayName, onChange, isRequired, optionFetchError, multiple, disabled }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION.';
    const [value, setValue] = useState(multiple ? [] : '');
    const [tab, setTab] = useState(0);
    const inputRefreshGlobal = useRecoilValue(inputRefresh);
    // const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (action.fields) {
            if (!action.fields[inputName]) {
                const defaultOption = options.find(x => x.default);
                action.fields[inputName] = { type, isRequired: isRequired, value: defaultOption ? defaultOption.value : '', tab: 0 };
            } else if (action.fields[inputName]?.tab !== undefined) {
                setTab(action.fields[inputName].tab);
            } else {
                const defaultOption = options.find(x => x.default);
                if (defaultOption) {
                    action.fields[inputName].value = defaultOption.value;
                }
                action.fields[inputName].tab = 0;
                setTab(0);
            }
            setValue(action.fields[inputName].value)
            // if (inputRefreshGlobal) {
            //     let changeDate = new Date(inputRefreshGlobal)
            //     let currentDate = new Date()
            //     const milisecondDiff = Math.abs(currentDate - changeDate);

            //     const secondDiff = milisecondDiff / 1000;
            //     // This process was used for dropdown instantaneous data transfer
            //     if (secondDiff < 5) {
            //         setLoading(true)
            //         setTimeout(() => {
            //             setLoading(false)
            //         }, 100)
            //     }
            // }


        } else if (action[inputName]) {
            if (action[inputName].tab === undefined) {
                const defaultOption = options.find(x => x.default);
                if (defaultOption) {
                    action[inputName].value = defaultOption.value;
                }
                action[inputName].tab = 0;
                setTab(0);
            } else {
                setTab(action[inputName].tab);
            }
            //setValue(action[inputName].value)
            setValue(action[inputName].value ? action[inputName].value : (multiple ? [] : ''))
        } else {
            action[inputName] = { type, isRequired: isRequired, value: '', tab: 0 }
        }
        if (optionFetchError) {
            setTab(1);
        }
    }, [inputRefreshGlobal, inputName])

    const ChangeTab = (newTab) => {
        // if you select the tab, the value will be assigned if it is inside
        if (newTab === 0) {
            if (action.fields) {
                if (options.find(x => x.value === action.fields[inputName].value)) {
                    setValue(action.fields[inputName].value);
                } else {
                    action.fields[inputName].value = '';
                    setValue('');
                }
            } else if (action[inputName]) {
                if (options.find(x => x.value === action[inputName].value)) {
                    setValue(action[inputName].value);
                } else {
                    action[inputName].value = '';
                    setValue('');
                }
            }
        }
        // change new tab
        setTab(newTab);
        if (action.fields && action.fields[inputName]) {
            action.fields[inputName].tab = newTab;
        } else if (action[inputName]) {
            action[inputName].tab = newTab;
        }
    };

    const changeSelection = (data) => {
        let v = ''
        if (multiple) {
            v = data.map((v) => v.value ? v.value : v);
        } else {
            v = data && data.value ? data.value : '';
        }

        setValue(v);
        onChange(v);
    }

    const checkValue = () => {
        // let v = options[multiple ? "filter" : 'find'](option => option.value === "" ? value === option.value : value.includes(option.value));
        let v = options[multiple ? "filter" : 'find'](option => value === option.value);
        return v !== undefined ? v : null;
    }
    return (
        <div>
            <div className="condition-tabs">
                <button
                    disabled={!!optionFetchError}
                    className={`f-s-11 ${tab === 0 ? 'condition-active' : ''}`}
                    onClick={() => ChangeTab(0)}>
                    {t(label + "SELECT")}
                </button>
                <button
                    className={`f-s-11 ${tab === 1 ? 'condition-active' : ''}`}
                    onClick={() => ChangeTab(1)}>
                    {t(label + "TEXT")}
                </button>
            </div>

            <TabPanel value={tab} index={0} >
                {/* {
                    isRequired && !value && <small style={{ color: '#D75E5E' }}>&nbsp; {t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>
                } */}

                <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                >
                    {/* <Select
                        labelId="demo-simple-select-outlined-label"
                        style={{
                            backgroundColor: "#fff",
                            height: "40px",
                            fontSize: "12px",
                        }}
                        value={value}
                        id="demo-simple-select-outlined"
                        displayEmpty
                        onChange={changeSelection}
                    >
                        {
                            options.map((cred, index) => (
                                <MenuItem
                                    style={{ fontSize: 12 }}
                                    value={cred.value}
                                    key={index}
                                >
                                    {cred.display_name}
                                </MenuItem>
                            ))}
                    </Select> */}
                    <Autocomplete
                        multiple={!!multiple}
                        style={{
                            backgroundColor: "#fff",
                            height: "40px",
                            fontSize: "3px",
                        }}
                        disabled={disabled}
                        onChange={(event, data, reason) => changeSelection(data)}
                        // value={options[multiple ? "filter" : 'find'](option => value.includes(option.value))}
                        value={value !== undefined ? checkValue() : null}
                        id="demo-simple-select-outline"
                        size="small"
                        options={options?.length > 0 && JSON.stringify(options[0]) !== '{}' ? options : []}
                        disableCloseOnSelect={!!multiple}
                        renderOption={multiple ? (option, { selected }) => (
                            <React.Fragment>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.display_name ? option.display_name : option}
                            </React.Fragment>
                        ) : undefined}

                        getOptionLabel={(item) => {
                            if (item?.display_name) {
                                return item.display_name
                            }
                            return item !== undefined ? item : null
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                    />
                </FormControl>
            </TabPanel>
            <TabPanel value={tab} index={1} >
                <TextInput
                    inputName={inputName}
                    action={action}
                    setField={setField}
                    variableRender={variableRender}
                    variables={variables}
                    include={[type]}
                    multiline={type === "object"}
                    setOpenVariable={setOpenVariable}
                    isRequired={isRequired}
                    fieldType={type}
                    displayName={displayName}
                    hideRequired={true}
                    disabled={disabled}
                />
            </TabPanel>
        </div>
    );
}

export default CustomTab
